module.exports = __webpack_public_path__ + "media/images/blank-profile-0b82bece0e97f0c494588dbdf31d83c9.jpg";